<script setup lang="ts">
import type { TextValueDto } from '@/api/generator';
import TextValue from '@/components/forms/dataTypes/TextValue.vue';
import { VeeTextValueProps } from '../types';
import { useField } from 'vee-validate';
import { toRef, computed } from 'vue';
import { useVeeFormProps } from '../utils';

const props = defineProps<VeeTextValueProps>();

const veeProps = useVeeFormProps(props);

const {
  value,
  handleBlur,
  handleChange,
  validate: validateBase,
  meta,
  errorMessage: errorMessageBase,
} = useField<TextValueDto | undefined>(
  toRef(() => props.name),
  undefined,
  {
    validateOnValueUpdate: false,
  },
);

const { validate: validateValue, errorMessage: errorMessageValue } = useField<string | undefined>(
  toRef(() => (value.value ? `${props.name}.value` : '')),
);

function validate() {
  validateBase();
  validateValue();
}

function onUpdate(input: TextValueDto | undefined) {
  handleChange(input, false);
  if (meta.touched) {
    validate();
  }
}

function onBlur(event: Event) {
  handleBlur(event);
  validate();
}

const errorMessage = computed(() => errorMessageBase.value || errorMessageValue.value);
</script>

<template>
  <TextValue
    v-bind="veeProps"
    :modelValue="value"
    :errorMessage="errorMessage"
    @update:modelValue="onUpdate"
    @blur="onBlur"
  />
</template>
